var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstaPaperIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "black",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.18 17.2048C30.18 17.328 30.002 17.4512 29.8788 17.4512C28.941 17.5813 26.7642 17.992 26.7642 18.7381V32.4287C26.7642 33.7361 29.8651 33.7361 29.9267 33.7361C30.0568 33.7361 30.18 33.8593 30.18 33.9826V34.9204C30.18 35.0436 30.0568 35.1668 29.9267 35.1668H19.4945C19.3644 35.1668 19.2412 35.0436 19.2412 34.9204V33.9826C19.2412 33.8593 19.3644 33.7361 19.4945 33.7361C19.4945 33.7361 19.515 33.7361 19.5561 33.7361C19.9942 33.7361 22.657 33.6814 22.657 32.4287V18.7381C22.657 18.1152 20.6034 17.6155 19.4808 17.4307C19.3576 17.4307 19.2344 17.3074 19.2344 17.1842V16.2464C19.2344 16.1232 19.3576 16 19.4808 16L29.9404 16.0205C30.0636 16.0205 30.1868 16.1506 30.1868 16.2738L30.18 17.2048Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaPaperIcon);
export default __webpack_public_path__ + "static/media/instaPaperIcon.35e5232da0911e87d7f0ce295a8ce8e2.svg";
export { ForwardRef as ReactComponent };